// extracted by mini-css-extract-plugin
module.exports = {"text-align-center":"_105329b597--text-align-center--wS6Cz","text-align-right":"_105329b597--text-align-right--EMFbI"};